import { render, staticRenderFns } from "./Naplata.vue?vue&type=template&id=14f83d88&scoped=true"
import script from "./Naplata.vue?vue&type=script&lang=js"
export * from "./Naplata.vue?vue&type=script&lang=js"
import style0 from "./Naplata.vue?vue&type=style&index=0&id=14f83d88&prod&scoped=true&lang=css"
import style1 from "./Naplata.vue?vue&type=style&index=1&id=14f83d88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f83d88",
  null
  
)

export default component.exports